import { StyledIconSmall, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';

import React from 'react';
import collapsedIcon from '@ingka/ssr-icon/paths/chevron-right';
import expandedIcon from '@ingka/ssr-icon/paths/chevron-down';
import { tokens } from '../../../../shared/styles/core/tokens';

type ExpandRowIconProps = {
   isExpanded: boolean;
};

export const ExpandRowIcon = ({ isExpanded }: ExpandRowIconProps) => {
   return (
      <StyledTooltip title={'Expand row'}>
         <div style={{ paddingRight: tokens.space.xs }}>
            <StyledIconSmall paths={isExpanded ? expandedIcon : collapsedIcon} />
         </div>
      </StyledTooltip>
   );
};
